import { useCallback, useEffect, useState } from 'react';

function computeReadingFocus() {
  if (typeof document === 'undefined') return false;
  return document.visibilityState === 'visible' && document.hasFocus();
}

/** true when the tab is visible and the window has OS focus — user is actively reading */
export function useWindowReadingFocus() {
  const [readingFocus, setReadingFocus] = useState(() => computeReadingFocus());

  const sync = useCallback(() => {
    setReadingFocus(computeReadingFocus());
  }, []);

  useEffect(() => {
    document.addEventListener('visibilitychange', sync);
    window.addEventListener('focus', sync);
    window.addEventListener('blur', sync);
    sync();
    return () => {
      document.removeEventListener('visibilitychange', sync);
      window.removeEventListener('focus', sync);
      window.removeEventListener('blur', sync);
    };
  }, [sync]);

  return readingFocus;
}
